import { render, staticRenderFns } from "./UserTransferList.vue?vue&type=template&id=6e123aca&scoped=true"
import script from "./UserTransferList.vue?vue&type=script&lang=js"
export * from "./UserTransferList.vue?vue&type=script&lang=js"
import style0 from "./UserTransferList.vue?vue&type=style&index=0&id=6e123aca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e123aca",
  null
  
)

export default component.exports